import React from "react";
import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import Anim from "./Anim";
import { ShareBar } from "../BlogEnhancements";

export default function PostHero({ post, readTime }) {
  return (
    <section className="bg-emerald_deep pt-28 pb-12 md:pb-16" data-testid="post-hero">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <Anim>
          <nav aria-label="Breadcrumb" className="mb-6">
            <ol className="flex items-center gap-2 text-xs text-bone/40">
              <li><a href="/" className="hover:text-accent transition-colors">Home</a></li><li>/</li>
              <li><Link to="/blog" className="hover:text-accent transition-colors">Blog</Link></li><li>/</li>
              <li className="text-accent truncate max-w-[200px]">{post.title}</li>
            </ol>
          </nav>
        </Anim>
        {post.tags?.length > 0 && (
          <Anim delay={0.05}>
            <div className="flex flex-wrap gap-2 mb-4">
              {post.tags.map(tag => (
                <span key={tag} className="text-[10px] tracking-wider uppercase text-accent bg-accent/10 px-3 py-1 rounded-full font-medium">{tag}</span>
              ))}
            </div>
          </Anim>
        )}
        <Anim delay={0.1}>
          <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-bone mb-6" data-testid="post-title">
            {post.title}
          </h1>
        </Anim>
        <Anim delay={0.2}>
          <div className="flex items-center gap-6 text-sm text-bone/50 mb-6">
            <span className="flex items-center gap-1.5"><Clock size={14} /> {readTime} min read</span>
            <span>By {post.author || "Fitly India"}</span>
          </div>
          <ShareBar title={post.title} slug={post.slug} />
        </Anim>
      </div>
    </section>
  );
}
